module.exports = __webpack_public_path__ + "static/img/2.4aff361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpg
// module id = 2Bxi
// module chunks = 0